<template>
  <div class="filemeeting">
    <div class="boxs-filemeeting">
      <v-card width="90%" class="box-filemeeting">
        <div class="r-text-boxs-filemeeting">
          <h6>مهارت خود آگاهی</h6>
          <span>خودآگاهی</span>
          <p>2,258بازدید</p>
          <h5>دوره مهارت های زندگی</h5>
        </div>
        <div class="date-boxs-filemeeting">
          <span>00:20:17</span>
          <v-icon>query_builder</v-icon>
        </div>
      </v-card>
      <v-card width="90%" class="box-received">
        <h6>
          برای دسترسی کامل و مشاهده این آموزش به صفحه دریافت این آموزش مراجعه
          نمایید
        </h6>
        <div class="btn-box-received">
          <v-btn color="#50ac17" width="90%" to="payment">
            <v-icon>vpn_key</v-icon>
            صفحه دریافت آموزش
          </v-btn>
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
export default {
  name: "filemeeting",
};
</script>
<style>
.filemeeting {
  background-image: url("/img/background.15817e10.jpg");
  height: 100%;
  position: relative;
  background-size: cover;
  padding: 0;
  z-index: 10;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 65px;
  overflow: hidden;
}
.box-filemeeting {
  overflow: auto;
  height: calc(100% - 60px);
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 60px;
}
.r-text-boxs-filemeeting {
  display: flex;
  flex-direction: column;
  padding: 5px;
}
.r-text-boxs-filemeeting h6 {
  font-size: 14px;
}
.r-text-boxs-filemeeting h5 {
  font-size: 13px;
  font-weight: 100;
}
.r-text-boxs-filemeeting span,
.r-text-boxs-filemeeting p {
  font-size: 11px;
  color: #707070;
  padding: 2px;
}
.box-filemeeting,
.box-received {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}
.date-boxs-filemeeting {
  display: flex;
  align-items: flex-start;
  padding: 5px;
}
.date-boxs-filemeeting,
.date-boxs-filemeeting .v-icon {
  font-size: 12px;
  color: #707070;
}
.date-boxs-filemeeting .v-icon {
  font-size: 15px;
}
.btn-box-received a {
  color: #fff !important;
}
.btn-box-received button {
  font-size: 12px !important;
  margin: 0 auto;
  display: flex;
  border-radius: none !important;
}
.btn-box-received {
  padding: 20px;
}
.btn-box-received .v-icon {
  font-size: 15px;
  padding: 15px;
}
.box-received {
  margin-top: 20px;
  flex-direction: column;
}
.box-received h6 {
  color: #707070;
  padding: 10px;
  font-size: 12px;
  font-weight: 100;
}
</style>
